export const REPAYMENT_SCHEDULE = '/zero/preview-schedule'
export const GET_CARD_DETAILS = '/zero/fetch-payment-instrument'
export const DOWN_PAYMENT = '/zero/debit-card'
